import React from 'react'
import { Link } from 'react-router-dom'
import Page_1 from '../../../assets/images/about/arrow-brudcrumb.svg'
import Blogimg from '../../../assets/images/background/blog-page-bg.jpg'

const PageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${Blogimg})`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>Stay updated with our latest posts</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Page_1} alt="icon" />
                        </li>
                        <li>
                            <span>Blog</span>
                        </li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default PageInear
